import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAndroid = function SvgAndroid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 16 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#A4C639",
        d: "M14.167 6.667C13.52 6.667 13 7.244 13 7.96v4.58c0 .715.521 1.293 1.167 1.293.645 0 1.166-.578 1.166-1.293V7.96c0-.71-.526-1.293-1.166-1.293M1.333 6.667c.646 0 1.167.577 1.167 1.293v4.58c0 .715-.521 1.293-1.167 1.293-.645 0-1.166-.578-1.166-1.293V7.96c0-.71.526-1.293 1.166-1.293"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#A4C639",
        fillRule: "evenodd",
        d: "M4.538.878a.36.36 0 0 0-.139.481l.781 1.41C3.772 3.571 2.834 5.01 2.831 6.65h9.902l-.004-.056c-.023-1.617-.956-3.032-2.348-3.827l.78-1.408a.354.354 0 1 0-.62-.342l-.8 1.442a5.3 5.3 0 0 0-1.96-.372c-.697 0-1.36.132-1.961.372l-.8-1.443a.354.354 0 0 0-.482-.139m8.197 6.164H2.831v7.18c0 .664.535 1.199 1.199 1.199h.594v2.44c0 .722.583 1.305 1.305 1.305.723 0 1.306-.583 1.306-1.305v-2.44h1.546v2.44c0 .722.584 1.305 1.306 1.305s1.305-.583 1.305-1.305v-2.44h.145c.663 0 1.198-.535 1.198-1.199zm-7.24-2.2a.412.412 0 1 1 .001-.823.412.412 0 0 1 0 .824m4.57 0a.412.412 0 1 1 0-.823.412.412 0 0 1 0 .824",
        clipRule: "evenodd"
    })));
};

export { SvgAndroid as ReactComponent };
//# sourceMappingURL=Android.svg.es.js.map
